
import {Component, Vue} from "vue-property-decorator";
import {Getter} from "vuex-class";
import SvgIcon from "@jamescoyle/vue-icon";
import { CGU_LINK } from "@/utils/constants";
import {
  mdiOfficeBuilding,
  mdiViewDashboard,
  mdiContentDuplicate,
  mdiBellAlert,
  mdiSwapHorizontal,
  mdiCogs,
  mdiQrcodeScan,
  mdiAccountKey,
  mdiBlockHelper,
  mdiAccountGroup,
  mdiKey,
  mdiStore,
  mdiCalendar,
  mdiContacts,
  mdiPlayBox,
} from "@mdi/js";
import Tutorials from "@/views/front-office/Tutorials.vue";

@Component({
  components: {
    SvgIcon,
  },
})
export default class SideNav extends Vue {

    @Getter private currentUser: any;
    @Getter private isMobileMenuOpen: boolean;
    @Getter private envCompanyId: number|null;
    @Getter("getDefaultNavItemList", { namespace: "nav" }) private defaultNavItemList: any[];
    @Getter("users/relays") private userRelays: any[];


  private icons = {
      mdiOfficeBuilding,
      mdiViewDashboard,
      mdiContentDuplicate,
      mdiBellAlert,
      mdiCogs,
      mdiQrcodeScan,
      mdiAccountKey,
      mdiBlockHelper,
      mdiAccountGroup: mdiContacts,
      mdiKey,
      mdiStore,
      mdiCalendar,
      mdiSwapHorizontal,
      mdiPlayBox,
    };

    private tutorials = {
      name: "tutorials",
      label: "nav.tutorialsMyloby",
      iconPath: "mdiPlayBox",
    };

    private CGU_LINK = CGU_LINK;

    public fetchPathByLabel(label) {
      if (this.icons[label]) {
        return this.icons[label];
      } else {
        // tslint:disable-next-line:no-console
        console.error("Maybe you forgot to import icon path: " + label);
        return this.icons.mdiBlockHelper;
      }
    }

    private computeTo(tab) {
      if (tab.name === "relays") {
        return this.userRelays?.length !== 1
            ? { name: "relays" }
            : { name: "relay", params: { id: this.userRelays[0]?.id } };

      } else {
        const to: any = { name: tab.name };
        if (tab.params) {
          to.params = tab.params;
        }
        return to;
      }
    }
}
